import 'reflect-metadata';
import {
    AfterLoad,
    BeforeInsert,
    Column,
    Entity,
    JoinTable,
    ManyToMany,
    OneToMany,
    PrimaryGeneratedColumn,
} from 'typeorm';
import {
    Activite,
    BaseEntite,
    EntiteStatique,
    Fournisseur,
    EntiteSommaireStatique,
    FiltrableEntiteStatique,
} from './index';
import ClientContact from './client-contact.entity';
import CssContact from './css-contact.entity';
import ContactEntente from './contact-entente.entity';
import { Courriel } from './courriel.entity';

@FiltrableEntiteStatique<Contact>()
@EntiteSommaireStatique<Contact>()
@EntiteStatique()
@Entity('contact')
export class Contact implements BaseEntite {
    static key = 'contacts';

    static non_privileged_properties: (keyof Contact)[] = [];
    static regular_privileged_properties: (keyof Contact)[] = ['id', 'nom', 'prenom', 'name', 'civilite'];
    static admin_privileged_properties: (keyof Contact)[] = [];

    static proprietesSommaire = ['name', 'email', 'telephone', 'notes'] as (keyof Contact)[];

    constructor() {
        this.prenom = '';
        this.name = '';
        this.created_at = '';
        this.email = '';
        this.isAdmin = false;
        this.updatePassword = false;
        this.password_hash = '';
        this.telephone = '';
        this.notes = '';
        this.actif = true;
    }

    @PrimaryGeneratedColumn()
    id: number;
    @Column()
    nom: string;
    @Column({ nullable: true })
    prenom: string;
    name: string;
    @Column({ nullable: true })
    civilite: string;
    @Column({ nullable: true })
    created_at: string;
    @Column({ nullable: true })
    email: string;
    @Column({ nullable: true })
    password_hash: string;
    @Column({ nullable: true })
    telephone: string;
    @Column({ name: 'b_is_admin', nullable: true, default: false })
    isAdmin: boolean;
    @Column({ name: 'b_update_password', nullable: true, default: false })
    updatePassword: boolean;
    @Column({ nullable: true })
    notes: string;
    @Column({ name: 'b_actif', nullable: true, default: true })
    actif: boolean;

    @OneToMany(() => ClientContact, (clientContact: ClientContact) => clientContact.contact)
    clients: ClientContact[];

    @OneToMany(() => Fournisseur, (f: Fournisseur) => f.contact_gestionnaire)
    fournisseurs_gestionnaire: Fournisseur[];

    @OneToMany(() => Fournisseur, (f: Fournisseur) => f.contact_par_defaut)
    fournisseurs_defaut: Fournisseur[];

    @OneToMany(() => Activite, (a: Activite) => a.contact_par_defaut)
    activites_defaut: Activite[];

    @ManyToMany(() => Activite, (a: Activite) => a.contacts)
    @JoinTable({
        name: 'contact_activite',
        inverseJoinColumn: {
            name: 'fk_id_activite',
            referencedColumnName: 'id',
        },
        joinColumn: {
            name: 'fk_id_contact',
            referencedColumnName: 'id',
        },
    })
    activites: Activite[];

    @OneToMany(() => CssContact, (cssContact: CssContact) => cssContact.contact)
    centre_service_scolaires: CssContact[];

    @OneToMany(() => Courriel, (courriel: Courriel) => courriel.expediteur)
    courriels: Courriel[];

    @OneToMany(() => ContactEntente, (contactEntente: ContactEntente) => contactEntente.contact, { lazy: true })
    contactEntente: ContactEntente;

    @BeforeInsert()
    updateCreatedAt(): void {
        this.created_at = new Date().toUTCString();
    }
    @AfterLoad()
    setName(): void {
        this.name = (this.prenom ? this.prenom + ' ' : '') + this.nom;
    }
}
